// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Restaumatic_Services_Storage from "../Restaumatic.Services.Storage/index.js";
import * as Specular_Callback from "../Specular.Callback/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Effect.functorEffect);
var getJSONItem = /* #__PURE__ */ Restaumatic_Services_Storage.getJSONItem();
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var setJSONItem = /* #__PURE__ */ Restaumatic_Services_Storage.setJSONItem();
var newCallback = /* #__PURE__ */ Specular_Callback.newCallback();
var voidRight = /* #__PURE__ */ Data_Functor.voidRight(Specular_FRP_Base.functorEvent);
var map1 = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var newPersistentRef = function (dictMonadFRP) {
    var Monad0 = (dictMonadFRP.MonadCleanup1()).Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var MonadEffect0 = dictMonadFRP.MonadEffect0();
    var liftEffect = Effect_Class.liftEffect(MonadEffect0);
    var newRef = Specular_Ref.newRef(MonadEffect0);
    var discard1 = discard(Bind1);
    var subscribeDyn_ = Specular_FRP_Base.subscribeDyn_(dictMonadFRP);
    var pure = Control_Applicative.pure(Monad0.Applicative0());
    return function (dictEncode) {
        var setJSONItem1 = setJSONItem(dictEncode);
        return function (dictDecode) {
            var getJSONItem1 = getJSONItem(dictDecode);
            return function (storage) {
                return function (key) {
                    return function (defaultValue) {
                        return bind(liftEffect(map(Data_Maybe.fromMaybe(defaultValue))(getJSONItem1(storage)(key))))(function (initialValue) {
                            return bind(newRef(initialValue))(function (ref) {
                                return discard1(subscribeDyn_(setJSONItem1(storage)(key))(Specular_Ref.refValue(ref)))(function () {
                                    return pure(ref);
                                });
                            });
                        });
                    };
                };
            };
        };
    };
};
var newPersistentFormFieldE = function (dictMonadFRP) {
    var Monad0 = (dictMonadFRP.MonadCleanup1()).Monad0();
    var bind = Control_Bind.bind(Monad0.Bind1());
    var newPersistentRef1 = newPersistentRef(dictMonadFRP);
    var newCallback1 = newCallback(dictMonadFRP.MonadEffect0());
    var holdDyn = Specular_FRP_Base.holdDyn(dictMonadFRP);
    var pure = Control_Applicative.pure(Monad0.Applicative0());
    return function (dictDecode) {
        return function (dictEncode) {
            var newPersistentRef2 = newPersistentRef1(dictEncode)(dictDecode);
            return function (storage) {
                return function (key) {
                    return function (v) {
                        return function (remoteState) {
                            return function (initial) {
                                return bind(newPersistentRef2(storage)(key)(initial))(function (ref) {
                                    return bind(newCallback1)(function (focusOutCallback) {
                                        return bind(holdDyn(false)(Specular_FRP_Base.leftmost([ voidRight(true)(focusOutCallback.event), voidRight(true)(remoteState.submitOccured) ])))(function (isTouched) {
                                            return pure({
                                                editRef: ref,
                                                focusOutCallback: focusOutCallback.callback,
                                                finalValue: map1(v.toFinal)(Specular_Ref.refValue(ref)),
                                                isTouched: isTouched,
                                                remoteState: remoteState
                                            });
                                        });
                                    });
                                });
                            };
                        };
                    };
                };
            };
        };
    };
};
var newPersistentFormField = function (dictMonadFRP) {
    var newPersistentFormFieldE1 = newPersistentFormFieldE(dictMonadFRP);
    return function (dictDecode) {
        var newPersistentFormFieldE2 = newPersistentFormFieldE1(dictDecode);
        return function (dictEncode) {
            var newPersistentFormFieldE3 = newPersistentFormFieldE2(dictEncode);
            return function (storage) {
                return function (key) {
                    return function (v) {
                        return function (remoteState) {
                            return function (initial) {
                                return newPersistentFormFieldE3(storage)(key)(v)(remoteState)(v.fromInitial(initial));
                            };
                        };
                    };
                };
            };
        };
    };
};
export {
    newPersistentFormFieldE,
    newPersistentFormField,
    newPersistentRef
};
